<template>
  <div>
    {{ date }}
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      date: new Date(),
    };
  },
  mounted() {
    if (
      this.params.column.colDef.field === "date" &&
      this.$route.path !== "/invoice" &&
      this.$route.path !== "/receipt"
    ) {
      this.date = moment(this.params.value).format("MM/YYYY");
    } else {
      this.date = moment(this.params.value).format("DD/MM/YYYY");
    }
  },
  methods: {},
};
</script>
